import { Workbox } from 'workbox-window'
import { showNewUpdateIsAvailableSnackbar } from '$comp/snackbars'
import { forceUpdateWebDialogApi } from '$comp/modals/force-update-web/force-update-web-dialog'
import { showWebForceUpdateModal } from '$comp/modals/force-update-web/force-reload-web-api'
import { getCurrentRelease } from '$logic/client-device/storage'
import { DeferredPromise } from '$func/deferred-promise'
import { fullReload } from '$func/fullReload.js'
import { envMode, envModes } from '$config/env'
import { VERSION } from '$setup/version'

let isForceUpdate = false
let shouldShowAlert = false

type TRegistrationUpdatePromise = () => Promise<void>

const registrationUpdatePromise =
  new DeferredPromise<TRegistrationUpdatePromise>()

export const forceUpdateWeb = async (version: string) => {
  // shouldShowAlert = true
  // isForceUpdate = forced
  if (getCurrentRelease().version === version) return
  registrationUpdatePromise
    .wait()
    .then((cb: TRegistrationUpdatePromise) => showWebForceUpdateModal(cb))
}

if ('serviceWorker' in navigator && envMode === envModes.PRODUCTION) {
  const wb = new Workbox('/sw.js')

  wb.addEventListener('waiting', async () => {
    const version = await wb.messageSW({ type: 'GET_VERSION' })
    console.log('>>>> [Workbox] waiting event', version)

    const timeout = setTimeout(
      () => forceUpdateWebDialogApi.finishProgress(),
      3000,
    )

    // Set up a listener that will reload the page as soon as the previously waiting service worker has taken control.
    wb.addEventListener('controlling', async () => {
      // should perform different action based in isForceUpdate

      clearTimeout(timeout)
      const newVersion = await wb.messageSW({ type: 'GET_VERSION' })

      console.log('>>>> [Workbox] controlling event:', {
        oldVersion: VERSION,
        newVersion,
      })

      // NOTE: Maybe this snackbar and force reload page appear together
      if (newVersion.version !== VERSION) {
        showNewUpdateIsAvailableSnackbar(fullReload)
        forceUpdateWebDialogApi.finishProgress()
      }
    })

    // This will postMessage() to the waiting service worker.
    wb.messageSkipWaiting()
  })

  wb.addEventListener('installed', async () => {
    const version = await wb.messageSW({ type: 'GET_VERSION' })
    console.log('>>>> [Workbox] installed SW', version)
  })

  wb.addEventListener('activated', async () => {
    const version = await wb.messageSW({ type: 'GET_VERSION' })
    console.log('>>>> [Workbox] activated SW', version)
  })

  // Register the service worker after event listeners have been added.
  wb.register().then(registration => {
    // Registration update method
    registrationUpdatePromise.resolve(registration.update.bind(registration))
  })
}
